// src/api/userInstitution.js
import { ENV } from "../Utils";

export class InstitutionApi {
  baseApi = ENV.BASE_API;

  async createInstitution(accessToken, formValue) {
    try {
      const formData = new FormData();
      // datos usuario
      formData.append("avatar", formValue.fileAvatar);
      formData.append("firstname", formValue.firstname);
      formData.append("lastname", formValue.lastname);
      formData.append("email", formValue.email);
      formData.append("password", formValue.password);
      formData.append("role", formValue.role);
      formData.append("partnerId", formValue.partnerId);
      formData.append("active", false);
      // datos InstitutionRevi
      formData.append("institutionName", formValue.institutionName);
      formData.append("address", formValue.address);
      formData.append("city", formValue.city);
      formData.append("country", formValue.country);
      formData.append("phone", formValue.phone);
      formData.append("website", formValue.website);
      formData.append("planEducaId", formValue.planEducaId);
      formData.append("pacientesN", formValue.pacientesN);
      formData.append("terapeutasN", formValue.terapeutasN);

      // opcionales
      if (formValue.idClient) {
        formData.append("idClient", formValue.idClient);
      }
      if (formValue.active !== undefined) {
        formData.append("active", formValue.active);
      }

      const url = `${this.baseApi}/${ENV.API_ROUTES.INSTITUTION}/create`;
      const res = await fetch(url, {
        method: "POST",
        headers: { Authorization: `Bearer ${accessToken}` },
        body: formData,
      });
      const json = await res.json();
      if (res.status !== 200) throw new Error(json.message);
      return json;
    } catch (err) {
      console.error("Error en createInstitution:", err);
      throw err;
    }
  }

  async getInstitutions(accessToken, partnerId, active) {
    let url = `${this.baseApi}/${ENV.API_ROUTES.INSTITUTION}/get/${partnerId}`;
    // Solo añadimos ?active si active es verdadero o falso
    if (typeof active === "boolean") {
      url += `?active=${active}`;
    }
    const res = await fetch(url, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const json = await res.json();
    if (res.status !== 200) throw new Error(json.message);
    return json;
  }

  async getInstitutionById(accessToken, institutionId, active) {
    let url = `${this.baseApi}/${ENV.API_ROUTES.INSTITUTIONBYINSTITUTION}/get/${institutionId}`;
    if (typeof active === "boolean") {
      url += `?active=${active}`;
    }
    const res = await fetch(url, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const json = await res.json();
    if (res.status !== 200) throw new Error(json.message);
    return json;
  }

  // --- NUEVO MÉTODO PARA EL ROL REVI ---
  async getInstitutionProfile(accessToken, institutionId) {
    // Apunta a: /api/v1/institutionreviprofile/get/:id
    const url = `${this.baseApi}/${ENV.API_ROUTES.INSTITUTION_PROFILE}/get/${institutionId}`;

    const res = await fetch(url, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });

    const json = await res.json();

    // El backend devuelve { code: 200, institution: {...} }
    if (res.status !== 200) throw new Error(json.message);
    return json;
  }

  async updateInstitution(accessToken, institutionId, formValue) {
    try {
      const formData = new FormData();
      if (formValue.fileAvatar) formData.append("avatar", formValue.fileAvatar);
      if (formValue.firstname)
        formData.append("firstname", formValue.firstname);
      if (formValue.lastname) formData.append("lastname", formValue.lastname);
      if (formValue.email) formData.append("email", formValue.email);
      if (formValue.password) formData.append("password", formValue.password);
      if (formValue.role) formData.append("role", formValue.role);
      if (formValue.partnerId)
        formData.append("partnerId", formValue.partnerId);

      // campos modificables
      if (formValue.institutionName)
        formData.append("institutionName", formValue.institutionName);
      if (formValue.address) formData.append("address", formValue.address);
      if (formValue.city) formData.append("city", formValue.city);
      if (formValue.country) formData.append("country", formValue.country);
      if (formValue.phone) formData.append("phone", formValue.phone);
      if (formValue.website) formData.append("website", formValue.website);
      if (formValue.planEducaId)
        formData.append("planEducaId", formValue.planEducaId);
      if (formValue.pacientesN)
        formData.append("pacientesN", formValue.pacientesN);
      if (formValue.terapeutasN)
        formData.append("terapeutasN", formValue.terapeutasN);

      const url = `${this.baseApi}/${ENV.API_ROUTES.INSTITUTION}/${institutionId}`;
      const res = await fetch(url, {
        method: "PATCH",
        headers: { Authorization: `Bearer ${accessToken}` },
        body: formData,
      });
      const json = await res.json();
      if (res.status !== 200) throw new Error(json.message);
      return json;
    } catch (err) {
      console.error("Error en updateInstitution:", err);
      throw err;
    }
  }

  async deleteInstitution(accessToken, institutionId) {
    const url = `${this.baseApi}/${ENV.API_ROUTES.INSTITUTION}/${institutionId}`;
    const res = await fetch(url, {
      method: "DELETE",
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const json = await res.json();
    if (res.status !== 200) throw new Error(json.message);
    return json;
  }

  async toggleInstitutionActivation(accessToken, institutionId, active) {
    const url = `${this.baseApi}/${ENV.API_ROUTES.INSTITUTION}/activation/${institutionId}`;
    const res = await fetch(url, {
      method: "PATCH",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ active }),
    });
    const json = await res.json();
    if (res.status !== 200) throw new Error(json.message);
    return json;
  }
}
